import { populate } from "populate";

const raw = {
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: "fa618836-1a4d-4238-9ef1-b2bda902c0ae",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "4a8ded07-87c4-4c12-9964-ea2d9f9c9c18",
      type: "Sprite",
      name: "base",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "new_crop_cabbage",
      parent: "fa618836-1a4d-4238-9ef1-b2bda902c0ae",
      data: ""
    },
    {
      id: "572f81c5-53fc-4d06-a054-4bcecc013646",
      type: "Sprite",
      name: "avatar",
      nameSpace: "",
      className: "",
      x: 882,
      y: 457,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.5,
        y: 1.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "no_avatar",
      parent: "4a8ded07-87c4-4c12-9964-ea2d9f9c9c18",
      data: ""
    },
    {
      id: "8c70bbbe-83f8-44e2-8735-9315245bb5e2",
      type: "Sprite",
      name: "bg",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "new_crop_cabbage",
      parent: "4a8ded07-87c4-4c12-9964-ea2d9f9c9c18",
      data: ""
    },
    {
      id: "67c5c121-9710-433e-8e95-469c8784204e",
      type: "Text",
      name: "quota",
      nameSpace: "",
      className: "",
      x: 740,
      y: 158,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "NewCropUnlocked",
      localize: false,
      maxWidth: 644,
      maxHeight: 180,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#2d2e3d",
        stroke: "black",
        strokeThickness: 0,
        align: "center",
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "4a8ded07-87c4-4c12-9964-ea2d9f9c9c18",
      data: ""
    }
  ]
} as const;

export class CropUnlockLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  base: GameObject<PIXI.Sprite>;
  avatar: GameObject<PIXI.Sprite>;
  bg: GameObject<PIXI.Sprite>;
  quota: GameObject<PIXI.Text>;

  constructor() {
    populate(this, raw);
  }
}
